const ITEMS = [
  "One identity",
  "Many journeys",
  "Your control",
  "Built by lived experience",
  "Designed for independence",
  "Powered by technology",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      className="relative border-y border-white/10 bg-navy-800/50 py-5 overflow-hidden"
      aria-hidden="true"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track">
        {row.map((item, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="px-6 font-display text-lg sm:text-xl font-medium text-slate-300">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-teal" />
          </span>
        ))}
      </div>
    </div>
  );
};
